module.exports = __webpack_public_path__ + "static/media/passport.51bc0536.svg";